import React from 'react';
import PropTypes from 'prop-types';
import { Header, InsAndOuts, LateChanges, Milestones } from './components';

const MATCH_STATUS = PULSE.app.common.CONSTANTS.MATCH_STATUS;

export const TeamLineupsItem = ({ match, hasMilestones, status }) => {
    const isActiveMatch =
        status === MATCH_STATUS.CONFIRMED_TEAMS ||
        status === MATCH_STATUS.LIVE ||
        status === MATCH_STATUS.POSTGAME ||
        status === MATCH_STATUS.CONCLUDED;

    return (
        <div className="team-lineups__item">
            <Header match={match} />
            <InsAndOuts match={match} isActiveMatch={isActiveMatch} />
            {isActiveMatch ||
            hasMilestones ||
            (hasMilestones && status === MATCH_STATUS.UNCONFIRMED_TEAMS) ? ( // stops empty section being rendered
                <div className="team-lineups__sub-section">
                    <Milestones match={match} />
                    {status !== MATCH_STATUS.UNCONFIRMED_TEAMS ? (
                        <LateChanges match={match} />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

TeamLineupsItem.propTypes = {
    match: PropTypes.object.isRequired,
    hasMilestones: PropTypes.bool,
    status: PropTypes.string
};
